import * as React from 'react'
import ChatbotWrapper from '../../../components/ChatbotWrapper'
import Section from '../../../components/Section'
import styles from './styles.module.scss'
import { faDownload } from '@fortawesome/free-solid-svg-icons'

import API from '../../../api'
import { ifElse } from '../../../utilities'
import Markdown from 'react-markdown'
import { RainbowText } from '../../../components/RainbowText'
import { LargeRainbowButton } from '../../../components/RainbowButton'
import { useLocation } from 'react-router'
import TwoColumn from '../../../components/TwoColumn'

type VersionInfo = { version: string; rc?: number; link: string; changelog: { details: string; features: string; updates: string; fixes: string; notes: string } }

const getDownloadInfo = async (allowRC?: boolean) => {
  try {
    const response = await API.getDownloadInfo(allowRC)
    const { version, link, details, features, updates, fixes, notes, rc } = response
    return { version, rc, link, changelog: { details, features, updates, fixes, notes } }
  } catch (e) {
    return undefined
  }
}

const Download: React.FC = () => {
  const [info, setInfo] = React.useState<VersionInfo>()
  const location = useLocation()
  React.useEffect(() => {
    const params = new URLSearchParams(location.search)
    const getInfo = async () => {
      const versionInfo = await getDownloadInfo(params.get('allowRC') === 'true')
      setInfo(versionInfo)
      // if (versionInfo?.link) {
      //   // setTimeout(() => window.location.assign(versionInfo.link), 0)
      //   // window.open(versionInfo.link, '_blank', 'noopener,noreferrer')
      //   const iframe = document.createElement('iframe')
      //   iframe.style.display = 'none'
      //   iframe.src = versionInfo.link
      //   document.body.appendChild(iframe)
      // }
    }
    getInfo()
  }, [location])

  const RainbowTextWrapperLarge: React.FC<React.PropsWithChildren<{ noMargin?: boolean }>> = ({ children, noMargin }) => {
    return noMargin ? (
      <RainbowText className='display-6' reverse light text={children} />
    ) : (
      <p>
        <RainbowText className='display-6' reverse light text={children} />
      </p>
    )
  }

  // const RainbowTextWrapper: React.FC<React.PropsWithChildren<{ noMargin?: boolean }>> = ({ children, noMargin }) => {
  //   return noMargin ? (
  //     <RainbowText className='display-6' reverse light text={children} />
  //   ) : (
  //     <p>
  //       <RainbowText reverse light text={children} />
  //     </p>
  //   )
  // }

  const DracoBot: React.FC<React.PropsWithChildren<{ reverse?: boolean; light?: boolean }>> = ({ reverse = true, light = true }) => {
    return <RainbowText light={light} reverse={reverse} text='Draco.Bot' />
  }

  const versionNumber = () => {
    if (!info) return
    return 'v' + info.version + (info.rc ? '-rc' + info.rc : '')
  }

  const updateNewlines = (value?: string) => value?.replaceAll(/\r?\n/gi, '\n') ?? ''

  return (
    <ChatbotWrapper
      decorate
      title={`Draco.Bot ${versionNumber()}\nRelease Notes`}
      titleClassName={styles.center}
      containerWrap={false}
      header={ifElse(
        info,
        <div className={styles.buttons}>
          <LargeRainbowButton icon={faDownload} href={info?.link}>
            Download
            <br />
            <DracoBot /> {versionNumber()}
          </LargeRainbowButton>
          {ifElse(
            info?.rc,
            <h3>
              <br />
              <TwoColumn auto smallGap>
                <div>🥼</div>
                <RainbowTextWrapperLarge noMargin>Whitecoat Release</RainbowTextWrapperLarge>
              </TwoColumn>
            </h3>,
          )}
        </div>,
        <>Loading, please wait...</>,
      )}
    >
      <div className={styles.container}>
        {ifElse(
          info,
          <>
            {ifElse(
              info?.changelog.details,
              <Section containerClassName={styles.marked} title={`Release Details`} icon={<span className={styles.icon}>💙</span>} contentContainerClassName={styles.textContent}>
                <Markdown components={{ h3: RainbowTextWrapperLarge, h4: RainbowTextWrapperLarge }}>{updateNewlines(info?.changelog.details?.replaceAll('•', '*'))}</Markdown>
              </Section>,
              null,
            )}
            {ifElse(
              info?.changelog.features,
              <Section containerClassName={styles.marked} title={`Features`} icon={<span className={styles.icon}>🎉</span>} contentContainerClassName={styles.textContent}>
                <Markdown components={{ h3: RainbowTextWrapperLarge, h4: RainbowTextWrapperLarge }}>{updateNewlines(info?.changelog.features?.replaceAll('•', '*'))}</Markdown>
              </Section>,
              null,
            )}
            {ifElse(
              info?.changelog.updates,
              <Section containerClassName={styles.marked} title={`Updates`} icon={<span className={styles.icon}>🆕</span>} contentContainerClassName={styles.textContent}>
                <Markdown components={{ h3: RainbowTextWrapperLarge, h4: RainbowTextWrapperLarge }}>{updateNewlines(info?.changelog.updates?.replaceAll('•', '*'))}</Markdown>
              </Section>,
              null,
            )}
            {ifElse(
              info?.changelog.fixes,
              <Section containerClassName={styles.marked} title={`Fixes`} icon={<span className={styles.icon}>🐞</span>} contentContainerClassName={styles.textContent}>
                <Markdown components={{ h3: RainbowTextWrapperLarge, h4: RainbowTextWrapperLarge }}>{updateNewlines(info?.changelog.fixes?.replaceAll('•', '*'))}</Markdown>
              </Section>,
              null,
            )}
            {ifElse(
              info?.changelog.notes,
              <Section containerClassName={styles.marked} title={`Important Notes`} icon={<span className={styles.icon}>📢</span>} contentContainerClassName={styles.textContent}>
                <Markdown components={{ h3: RainbowTextWrapperLarge, h4: RainbowTextWrapperLarge }}>{updateNewlines(info?.changelog.notes?.replaceAll('•', '*'))}</Markdown>
              </Section>,
              null,
            )}
          </>,
          <div>Loading Version Information, Please Wait...</div>,
        )}
      </div>
    </ChatbotWrapper>
  )
}

export default Download
